import { FC } from "react";
import { FormattedCategory } from "./CategoryWrapper";
import { styled } from "styled-components";
import { font } from "../lib/sharedStyles";

const Card = styled.a`
  display: flex;
  align-items: center;
  background: #F7F7F7;
  text-decoration: none;
  padding: 4px;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #cbcbcb;
  }
`;

const ImageSquare = styled.div<{ hasImage: boolean }>`
  display: flex;
  width: ${({ hasImage }) => (hasImage ? "52px" : "0")};
  height: 52px;
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 16px;
  margin-right: 16px;
  color: #191A1F;

  span:first-of-type {
    ${font('Instrument Sans', 600, '14px', '22px')}
  }

  span:last-of-type {
    ${font('Instrument Sans', 400, '12px', '18px')}
  }
`;

const CategoryCard: FC<FormattedCategory> = ({ title, description, url, imageUrl }) => (
  <Card href={url}>
    <ImageSquare hasImage={Boolean(imageUrl)}>
      {imageUrl && <Image src={imageUrl} />}
    </ImageSquare>
    <ContentWrapper>
      <span>{title}</span>
      <span>{description}</span>
    </ContentWrapper>
  </Card>
);

export default CategoryCard;